export default __webpack_public_path__ + "static/media/UserPlaceholder.b42931a7.svg";